

import { mapActions } from 'vuex';

// Assets
import listAdmin from '../assets/data/listAdmin';

// Store
import errorsMixin from '../mixins/error-handler';

// Models
import Location from '../models/location';

// API
import * as apiPlayground from '../api/public/playground';

// Mixins
import metaMixin from '../mixins/meta';

export default {
  name: 'ListCityAdmin',
  mixins: [errorsMixin, metaMixin],
  props: {
    admin: {
      type: String,
      default: null,
    },
  },
  async asyncData({ params, error }) {
    if (!listAdmin.some((admin) => admin.route === params.admin)) {
      error({ statusCode: 404 });
    }

    let listCities = [];
    const defaultErrors$ = [];
    const asyncErrors$ = [];
    await apiPlayground.adminCities({
      admin: params.admin,
    }, null).then((list) => {
      listCities = list.results;
    }).catch((e) => {
      if (e?.response?.data) {
        asyncErrors$.push(e.response.data);
      }
      defaultErrors$.push({ env: 'search_city', field: 'form' });
    });
    return {
      listCities, asyncErrors$, defaultErrors$,
    };
  },
  data() {
    return {
      displayCities: [],
      size: 15,
      page: 0,
      isLoading: false,
      isAtEnd: false,
      scrollerItemSize: 100, // Requires a default minimum size
      listIsScrollable: false,
      noResult: true,
    };
  },
  head() {
    return {
      title: this.metaTitle,
      meta: this.meta([{
        hid: 'description',
        name: 'description',
        content: this.metaDescription,
      }]),
    };
  },
  computed: {
    validAdmin() {
      return listAdmin.find((admin) => admin.route === this.admin);
    },
    accordAdmin() {
      return this.validAdmin?.accord;
    },
    labelAdmin() {
      return this.validAdmin?.label;
    },
    metaTitle() {
      return `Aires de jeux ${this.accordAdmin}${this.labelAdmin}`;
    },
    metaDescription() {
      return `Trouvez des aires de jeux ${this.accordAdmin}${this.labelAdmin}`;
    },
  },
  created() {
    this.noResult = !this.listCities || this.listCities.length <= 0;
    if (!this.noResult) {
      this.listCities.sort((a, b) => {
        if (a.city.alias < b.city.alias) { return -1; }
        return 1;
      });

      this.loadMore();
    }
  },
  methods: {
    ...mapActions({
      updateCurrentSearch: 'transferData/updateCurrentSearch',
    }),
    loadMore() {
      this.isLoading = true;
      const start = this.size * this.page;
      const end = this.size * (this.page + 1);
      this.displayCities.push(...this.listCities.slice(start, end));
      this.isAtEnd = this.listCities.length < end;
      this.page += 1;
      this.isLoading = false;
    },
    goToCity(location, routeData) {
      // Type 3 "city" by default
      location.type = 3;
      this.updateCurrentSearch(new Location(location));
      if (this.$matomo) {
        this.$matomo.trackEvent('Search', 'cityAdmin', location.city.alias);
      }
      this.$newRouter.push(routeData);
    },
    scrollEvent() {
      if (this.$refs.scrollerList) {
        // Reach bottom
        const scrollTop = this.$refs.scrollerList.scrollTop();
        const scrollHeight = this.$refs.scrollerList.scrollHeight() - this.$refs.scrollerList.offsetHeight();
        if (scrollHeight - scrollTop < 100) {
          if (!this.isLoading && !this.isAtEnd) {
            this.loadMore();
          }
        }
      }
    },
    scrollerResize() {
      // Wait to get the new size of the wrapper
      this.$nextTick(() => {
        // Load more results to fill the scrollable div
        if (this.$refs.scrollerList.offsetHeight() < this.$refs.scrollWrap.offsetHeight && !this.isLoading && !this.isAtEnd) {
          this.loadMore();
        }
      });
    },
  },
};
